import type { ContentSwitcherProps } from './ContentSwitcher.props'

const contentTop = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: {
            text: '<p>BODi - Terms &amp; Conditions of Use</p>',
            getValueFromCountdown: false,
            style: 'Display Heading 1',
            actionName: 'none',
            navigate: { href: '/', analyticsEvent: 'none' },
          },
        },
        responsiveStyles: { large: { height: 'auto', textAlign: 'left' } },
        meta: { previousId: 'builder-ea38cdedf4fb4bd6964d0865fbaa1898' },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: {
            text: '<p>Last Updated: September 27, 2024</p>',
            getValueFromCountdown: false,
            style: 'Body SM',
            actionName: 'none',
            navigate: { href: '/', analyticsEvent: 'none' },
          },
        },
        responsiveStyles: {
          large: {
            height: 'auto',
            textAlign: 'left',
            fontWeight: '600',
            color: 'var(--color-bodi-accent-deep-500)',
          },
        },
        meta: { previousId: 'builder-eb63a6c573ab49fe9e7e5da659558812' },
      },
    ],
    responsiveStyles: {
      large: {
        paddingBottom: '0px',
        gap: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        color: 'rgba(22, 24, 25, 1)',
      },
    },
    meta: { previousId: 'builder-4ab1d9e1eab148b484408ced6636ab63' },
  },
] as any

const contentBottom = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    meta: { previousId: 'builder-ec9add4627b74c6b84363f6683252342' },
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-f8728c44a7e74012b2fdbc012711800e' },
        component: {
          name: 'Text',
          options: {
            text: '<p><strong>For Residents of the United States and Canada</strong></p><p><br></p><p>Beachbody, LLC, dba BODi (in the United States) and Team Beachbody Canada LP, dba BODi Canada (in Canada) and each of their affiliates, subsidiaries and parent companies (collectively, “BODi”, “us”, “we” or “our”) are pleased to provide you with access to and use of our websites, mobile and device applications, content, streaming services, products, services, goods, equipment, equipment interfaces, promotions, software, technology and any other materials (collectively, “BODi Services”) that we may provide.<span class="ql-cursor">﻿</span></p><p><br></p><p>PLEASE READ CAREFULLY THIS INDIVIDUAL ARBITRATION AND CLASS ACTION WAIVER NOTICE: TO THE FULLEST EXTENT PERMITTED BY LAW, THESE TERMS (WHICH TERM IS DEFINED BELOW) CONTAIN A MANDATORY INDIVIDUAL ARBITRATION AGREEMENT AND CLASS ACTION WAIVER, REQUIRING YOU TO RESOLVE ANY DISPUTE (AS DEFINED BELOW) BETWEEN YOU AND BODI THROUGH FINAL AND BINDING INDIVIDUAL ARBITRATION, INSTEAD OF IN COURT, AND, TO THE FULLEST EXTENT PERMITTED BY LAW, REQUIRING YOU TO FOREGO ALL JURY TRIALS AND ALL CLASS, COLLECTIVE, CONSOLIDATED, AGGREGATE, MASS, AND REPRESENTATIVE PROCEEDINGS, AND ALL OTHER TYPES OF COURT PROCEEDINGS OF ANY AND EVERY KIND, EXCEPT FOR CERTAIN MASS ARBITRATION PROCEEDINGS (SEE SECTION 9, SUBSECTION 9.5, BELOW) AND, IN THE U.S., INDIVIDUAL SMALL CLAIMS (AS DESCRIBED IN SECTION 9 BELOW). BY AGREEING TO THESE TERMS, YOU EXPRESSLY ACKNOWLEDGE THAT YOU HAVE READ, CAREFULLY CONSIDERED, AND UNDERSTAND ALL OF THE PROVISIONS OF THE INDIVIDUAL ARBITRATION AGREEMENT AND CLASS ACTION WAIVER PROVISIONS, AND THAT YOU EXPRESSLY AGREE TO BE BOUND THEREBY.</p><p><br></p><p>THE BODi SERVICES ARE NOT INTENDED FOR ANYONE UNDER THE AGE OF 13. IF YOU ARE 13 TO 17 YEARS OF AGE, YOU MAY ONLY ACCESS AND/OR USE ANY BODi SERVICES WITH THE INVOLVEMENT AND APPROVAL OF YOUR PARENT OR GUARDIAN.</p><p><br></p><p>FOR CANADIAN RESIDENTS: SEE BELOW FOR BUYER’S RIGHT TO CANCEL.&nbsp;The Buyer’s Right to Cancel applies to BODi end consumers referred by an independent BODi Partner. The Buyer’s Right to Cancel does not apply to independent BODi Partners.</p><p><br></p><p>1.&nbsp;Contract Between You and BODi; Privacy Policy.&nbsp;</p><p>These Terms and Conditions of Use (“Terms”) and our Privacy Policy (available&nbsp;here) form a legally binding agreement between you and BODi, and govern your access and use, and our provision of, the BODi Services and any other technology, content, items or other materials provided by or through BODi, or otherwise on which these Terms are provided (including via links). BY ACCESSING OR USING ANY BODi SERVICE, YOU AGREE TO BE BOUND AND ABIDE BY THESE TERMS (INCLUDING WITHOUT LIMITATION&nbsp;SECTION 9&nbsp;BELOW), OUR PRIVACY POLICY AND ANY AMENDMENTS THERETO, AND YOU AGREE YOU ARE AT LEAST 13 YEARS OF AGE.</p><p>Supplemental terms and conditions may apply to certain BODi Services, such as rules for a particular contest, sweepstakes, competition, or other activity, or terms that may accompany certain content,</p><p>software or other materials accessible through the BODi Services, such as terms related to BODi streaming services (e.g., One-Day Pass Terms and Conditions, BODcast Rules, Codes of Conduct, etc.) (“Supplemental&nbsp;Terms”). Any Supplemental Terms will be disclosed to you in connection with those other activities and will apply and govern specifically over such activities.</p><p>Please note that for BODi Partners, in the event of any direct conflict between these Terms and the BODi U.S. Distributor Policies and Procedures and Compensation Plan (collectively, “P&amp;P”), the P&amp;P will govern and control, provided however that if there is a direct conflict between the Disputes, Binding Individual Arbitration, and Waiver of Class Actions &amp; Class Arbitration provision found in Section 9 of these Terms and the Dispute Resolution section found in the P&amp;P, Section 9 of these Terms will govern and control.</p><p><br></p><p>You must only use the BODi Services for lawful purposes and in compliance with any applicable Codes of Conduct, and you must not use them in a way that is illegal or harmful, or infringes the rights of anyone else or that restricts or inhibits anyone else\'s enjoyment of any BODi Services. In using any BODi Services, and in particular, our websites, you expressly acknowledge you are prohibited from, and agree that you will not without our prior express written consent:</p>',
            getValueFromCountdown: false,
            style: 'Body MD',
            actionName: 'none',
            navigate: { href: '/', analyticsEvent: 'none' },
          },
        },
        responsiveStyles: { large: { height: 'auto', textAlign: 'left', marginTop: '24px' } },
      },
    ],
    responsiveStyles: { large: { height: 'auto', paddingBottom: '30px' } },
  },
] as any

export const ContentSwitcherDefaults: ContentSwitcherProps = {
  items: [
    {
      title: 'English US',
      contentTop,
      contentBottom,
    },
  ],
  defaultIndex: 0,
}
